import type { schemas } from '@gonfalon/openapi/types';

export const DEFAULT_AI_CONFIG_APPROVAL_SETTING: schemas['ApprovalRequestSetting'] = {
  autoApplyApprovedChanges: null,
  bypassApprovalsForPendingChanges: false,
  canApplyDeclinedChanges: true,
  canReviewOwnRequest: false,
  minNumApprovals: 1,
  required: false,
  requiredApprovalTags: [],
  serviceConfig: {},
  serviceKind: 'launchdarkly',
  serviceKindConfigurationId: null,
};
